// extracted by mini-css-extract-plugin
module.exports = {"container":"LabeledIcon_container__dCU2G","text":"LabeledIcon_text__IjBOT","icon":"LabeledIcon_icon__rszgi"};